<template>
    <div class="component-wrap">
        <v-card>
            <div v-if="loaded">
                <v-card-title class="d-flex flex-row secondary">
                    <span>{{ item.code }}</span>
                    <v-chip :class="classByStatus(item.status_id)" class="ml-2">{{ status(item.status_id).name }}
                    </v-chip>

                    <v-switch
                            v-model="service"
                            label="Service"
                            color="info"
                            class="ml-auto"
                            inset
                    ></v-switch>
                </v-card-title>

                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" sm="6">
                            <h3>Hash rate: {{ item.hash_rate_percent }}% / {{ item.hash_rate }} / {{ item.excepted_hash_rate }}</h3>
                            <h3 class="my-1">Graphic cards ({{ item.gpus.length }})</h3>
                            <v-chip class="ma-1" v-for="(item, i) in item.gpus" :key="i">
                                {{ item.name }}
                            </v-chip>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <h3 class="my-1">Status history</h3>
                            <v-data-table
                                    dense
                                    :page="page"
                                    :pageCount="numberOfPages"
                                    :headers="headers"
                                    :items="statusHistories"
                                    :options.sync="options"
                                    :footer-props="footerProps"
                                    :server-items-length="totalStatusHistories"
                                    :loading="loading"
                                    class="elevation-0"
                            >
                                <template v-slot:item.computer_status_id="{ item }">
                                    <v-chip small :color="classByStatus(item.computer_status_id)" dark>
                                        {{ statuses[item.computer_status_id].name }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <v-btn color="secondary" @click="back">Close</v-btn>
                </v-card-actions>
            </div>
            <div v-if="!loaded">Loading...</div>
        </v-card>
    </div>
</template>

<script>

    import {mapGetters, mapState} from "vuex";
    import axios from "axios";

    export default {
        props: {
            propItemId: {
                required: true
            }
        },
        mounted() {
            this.readDataFromAPI();
        },
        computed: {
            ...mapState({
                loaded: state => state.computers.loaded,
                statuses: state => state.statuses.items,
            }),
            ...mapGetters('statuses', {
                status: 'byId',
                classByStatus: 'styleClass',
            }),
            item() {
                return this.$store.getters['computers/byId'](this.propItemId)
            },
            service: {
                get() {
                    return this.item.status_id === 6;
                },
                set(value) {
                    this.toggleService(value);
                }
            },
        },
        data() {
            return {
                page: 1,
                totalStatusHistories: 0,
                numberOfPages: 0,
                statusHistories: [],
                loading: true,
                options: {
                    mustSort: true,
                    sortBy: ['updated_at'],
                    sortDesc: ['false'],
                },
                footerProps: {
                    itemsPerPageOptions: [20],
                },
                headers: [
                    {text: "Status Id", value: "computer_status_id"},
                    {text: "Hash Rate", value: "hash_rate"},
                    {text: "Updated At", value: "updated_at"},
                ],
                backRoute: {path: '/computers'},
            }
        },
        watch: {
            options: {
                handler() {
                    this.readDataFromAPI();
                },
            },
            deep: true,
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            toggleService() {
                axios
                    .get(process.env.VUE_APP_API_URL + "/computers/" + this.propItemId + "/toggle-service")
                    .then((response) => {
                        this.$store.commit('computers/setStatusId', response.data);
                        this.readDataFromAPI();
                    });
            },
            readDataFromAPI() {
                this.loading = true;
                const {page, sortBy, sortDesc} = this.options;
                axios
                    .get(
                        process.env.VUE_APP_API_URL + "/computer-status-histories?filter[computer_id]=" + this.propItemId
                        + "&sort=" + (sortDesc[0] ? '-' + sortBy : '' + sortBy) +
                        "&page=" + page
                    )
                    .then((response) => {
                        this.loading = false;
                        this.statusHistories = response.data;
                        this.totalStatusHistories = parseInt(response.headers['x-pagination-total-count']);
                        this.numberOfPages = parseInt(response.headers['x-pagination-page-count']);
                    });
            },

        }
    }
</script>
